<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title d-flex align-items-center">
          <span class="mr-2 mt-2 mb-2">Create New Folder</span>
          <Loader v-if="updating"/>
        </p>
        <button @click="close()" class="delete"></button>
      </header>

      <footer class="modal-card-foot">
        <div class="w-100">
          <form @submit.prevent="createFolder">
            <div class="field has-addons w-100p">
              <div class="control is-medium grow-1" :class="creating && 'is-loading'">
                <input
                  v-model="folderTitle"
                  class="input is-medium"
                  placeholder="New folder name" />
              </div>
              <div class="control is-medium">
                <button class="button is-primary is-medium"
                    :class="creating && 'is-loading'"
                    type="submit">
                    Create
                </button>
              </div>
            </div>
          </form>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import store from '../store'

import FolderIcon from './FolderIcon.vue'
import FolderAddIcon from './FolderAddIcon.vue'
import Loader from './Loader'

export default {
  name: 'AddFolderModal',
  components: {
    FolderIcon,
    FolderAddIcon,
    Loader,
  },
  data () {
    return {
      showNewFolderModal: false,
      loading: true,
      updating: false,
      creating: false,
      folderTitle: '',
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async createFolder () {
      this.creating = true
      await store.dispatch('createFolder', { title: this.folderTitle })
      this.folderTitle = ''
      this.creating = false
      this.close()
    },
  },
}
</script>



// WEBPACK FOOTER //
// AddFolderModal.vue?78a2db28